module.exports = __webpack_public_path__ + "static/media/lol-silver.1c715b85.png";